const React = require('react');
const toLower = require('mn-utils/toLower');
const formatTime = require('mn-utils/formatTime');
const upperFirst = require('mn-utils/upperFirst');

const {pushLocation} = require('../../../../../../router');
const formatNumCurrency = require('../../../../../../utils/formatNumCurrency');
const {LINK_INVOICE} = require('../../../../../../constants/links');

const Tooltip = require('../../../../../dumb/Tooltip/B');
const MenuForItem = require('../../../../../dumb/Menu/ForItem');

const {ICONS_MAP, DEFAULT_ICON} = require('../constants/icons');

const {
  getRFC3339,
} = formatTime;

module.exports = (props) => {
  const {
    data,
  } = props;
  const {
    id,
    amount,
  } = data;
  const fiatCode = data.currency_code;
  const volume = data.trx_amount || 0;
  const status = toLower(data.state || '');
  const time = data.created_at || '';
  const fileId = data.file_id || false;

  return (
    <div
      className={`w layoutRow fhaS fvaC h112 rlv lh fw7 f12 c2 tc lts0em
            ph20 (ph10|w1/5)>1 bgF6F6F6.even`
        + (props.index % 2 === 1 ? ' even' : '')}
    >
      <div className="pl25@d2">
        <div className="layoutRow fvaC fhaS tl">
          {ICONS_MAP[status] || DEFAULT_ICON}
          <div className="pl20 fx1 wmin0">
            <div className="f14 fw7 lts0em wsNW ov tov wmax lh130%">
              {data.number}
            </div>
            <div className="wsNW ov tov wmax c8E8EA1 mt3 f12 fw4">
              {data.currency_code}
            </div>
          </div>
        </div>
      </div>
      <div>
        <Tooltip title={amount}>
          {formatNumCurrency(amount)} {fiatCode}
        </Tooltip>
      </div>
      <div>
        <Tooltip title={volume}>
          {formatNumCurrency(volume)} {fiatCode}
        </Tooltip>
      </div>
      <div>
        {time ? (
          <Tooltip title={getRFC3339(time)}>
            <div>
              {formatTime(time, '{dd} {mmm}, {yyyy}')}
            </div>
          </Tooltip>
        ) : null}
      </div>
      <div>
        <div
          className={`lh lts0em c0 cFFBF43.pending c2CE889.paid ` + status}
        >{upperFirst(status)}</div>
        <MenuForItem items={[
          {
            name: 'Details',
            onClick() {
              pushLocation({
                path: `${LINK_INVOICE}/${id}`,
              });
            },
          },
          fileId && (
            {
              name: `Download PDF`,
              onClick() {
                window.open('/f2c/v1/console/file/' + fileId, '_blank').focus();
              }
            }
          )
        ].filter((el) => !!el)}/>
      </div>
    </div>
  );
};
